import { Fragment } from 'react'

import WebView from './WebView'

type PropsType = {
  show: boolean
  menus: any[]
  children: React.ReactNode
}

export interface WebBrowserRef {
  handleReload: () => void
}

const Index = ({ show = false, menus = [], children }: PropsType) => {
  return (
    <div id="WebBrowser" className={`${show ? 'flex' : 'hidden'} w-full h-full  flex-col justify-start items-center bg-[#ececec] p-2 relative z-10`}>
      <div className="w-full h-10 overflow-hidden overflow-x-auto no-scrollbar ">
        <div className="w-auto h-full flex flex-row flex-nowrap  justify-start items-end">
          {menus.map((item) => {
            return (
              <div
                key={`$tab-${item.selectIndex}`}
                className={`flex justify-between items-center w-36 basis-36 shrink-0 h-8 ext-center rounded-t-md text-sm  px-2 mr-[0.1rem] ${item.selected ? ' bg-[#3B66E9] text-white' : 'bg-[#3B66E9] text-[#92AAF1]'}`} //'bg-[#E2E3ED] text-[#8C8DA1]'}
              >
                {item?.stuUrl ? item.title || `标签页` : '新标签页'}
                {/* <AiFillCloseCircle className="text-sm text-[#c1c2c3]" /> */}
              </div>
            )
          })}

          {/* <div className="flex justify-around items-center w-10 basis-10 shrink-0 h-8 bg-[#E2E3ED]  text-sm rounded-t-md">
            <AiOutlinePlus />
          </div> */}
        </div>
      </div>
      <div className="flex justify-center items-center w-full h-12 bg-white px-4 inset-shadow-sm select-none">
        {/* <div className="flex w-[18%] h-full justify-between items-center">
          <AiOutlineArrowLeft />
          <AiOutlineArrowRight />
          <AiOutlineReload className="cursor-pointer" onClick={() => handleReload()} />
        </div>
        <div className="flex flex-1 h-8 items-center rounded-full px-4 box-border bg-[#ececec] ml-4 text-sm whitespace-nowrap ">{tab.stuUrl ? tab.title || tab.stuUrl.toString() : '请输入网址'}</div> */}
      </div>
      {menus.length ? (
        menus?.map((item) => {
          return (
            <Fragment key={'webView_' + item.selectIndex}>
              <WebView url={item.stuUrl} selected={item.selected} reload={item.reload} />
            </Fragment>
          )
        })
      ) : (
        <div className={`w-full h-full webview-logo-bg bg-[#E2E3ED] rounded-md rounded-tl-none `}></div>
      )}
      {children}
    </div>
  )
}

export default Index
